import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { getWFHDetails, withdrawalWFHData } from "./WfhSerevice";
import TosterService from "../../../../Services/Toster-Service/TosterService";
import { TostMsg } from "../../../../App";
import { getTrans as T } from "../../../../Shared/Language";
import { Paginator } from "primereact/paginator";
import WfhNavBarItems from "./WfhCommon/WfhNavBarItems";
import WfhManagerReport from "./WfhCommon/WfhManagerReport";
import { orgSettings } from "../../../../Services/Global-Services/GlobalServices";
import { LazyImage } from "../../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { useSelector } from "react-redux";
import moment from "moment";
const ComponentLoader = React.lazy(() =>
  import("../../../../Shared/Sidebar/ComponentLoader")
);

function MyWfh() {
  const ApplyLeaveRequestData = useSelector(
    (state) => state.leave.leaveRequestData
  );
  const toster = useContext(TostMsg);
  const [WFHData, setWFHData] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [inputType, setInputType] = useState("date");
  const [Isloading, setIsloading] = useState(false);
  let Sdate = null;
  let EDate = null;
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [filterStartDate, setFilterStartDate] = useState(Sdate);
  const [filterEndDate, setFilterEndDate] = useState(EDate);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showWfhHistory, setshowWfhHistory] = useState(null);
  const [selectedHierarchyType, setSelectedHierarchyType] = useState("1");
  const [empIdHierechy, setEmpIdHierechy] = useState(userDetails?.EmpId);
  const [typeAddOnClass, settypeAddOnClass] = useState(null);
  const [showAllUserDataModel, setshowAllUserDataModel] = useState([]);
  const [resonValue, setResonValue] = useState("");
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const [noData, setNoData] = useState([]);

  const ResontextStyle = {
    maxWidth: "100%",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 3,
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "pointer",
  };

  useEffect(() => {
    GetMasterSystemAlertList("WFH_Unavailable", 2);
    if (ApplyLeaveRequestData) {
      settypeAddOnClass("P");
      setFilterEndDate(
        new Date(ApplyLeaveRequestData?.EndDate)?.toISOString()?.split("T")[0]
      );
      setFilterStartDate(
        new Date(ApplyLeaveRequestData?.StartDate)?.toISOString()?.split("T")[0]
      );
      getWFHData("P", pageNumber, pageSize);
    } else {
      OrgSettings();
    }
  }, []);

  const showFull = (id, expand) => {
    setWFHData((prev) =>
      prev.map((item) =>
        item.Id === id ? { ...item, showFull: expand } : item
      )
    );
  };

  const OrgSettings = useCallback(async () => {
    setIsloading(true);
    let param = {
      OrgId: userDetails?.OrgId,
    };
    try {
      let responce = await orgSettings(param);
      let StartDate = responce?.Data?.filter(
        (element) => element.KeyName == "LeaveFilterStartDate"
      );
      if (StartDate[0]?.Value != null) {
        Sdate = new Date(StartDate[0]?.Value)?.toISOString()?.split("T")[0];
      } else {
        Sdate = new Date(new Date() - 30 * 24 * 60 * 60 * 1000)
          ?.toISOString()
          ?.split("T")[0];
      }
      setFilterStartDate(Sdate);
      let EndDate = responce?.Data?.filter(
        (element) => element?.KeyName == "LeaveFilterEndDate"
      );
      if (EndDate[0]?.Value != null) {
        EDate = new Date(EndDate[0]?.Value)?.toISOString()?.split("T")[0];
      } else {
        EDate = new Date()?.toISOString()?.split("T")[0];
      }
      setFilterEndDate(EDate);
    } catch (error) {
      Sdate = new Date(new Date() - 30 * 24 * 60 * 60 * 1000)
        ?.toISOString()
        ?.split("T")[0];
      EDate = new Date()?.toISOString()?.split("T")[0];
      setFilterStartDate(Sdate);
      setFilterEndDate(EDate);
      setIsloading(false);
    }
  }, []);

  async function getWFHData(WFHStatusName, pageNumber, pageSize) {
    let wfhStatusName;
    if (WFHStatusName) {
      wfhStatusName = WFHStatusName;
    } else {
      wfhStatusName = "U";
    }
    settypeAddOnClass(wfhStatusName);
    setIsloading(true);
    const param = {
      OrgId: userDetails?.OrgId,
      LoggedInEmpId: userDetails?.EmpId,
      WFHid: 0,
      EmpId: userDetails?.EmpId,
      HierarchyTypeId: selectedHierarchyType,
      FilterStartDate: filterStartDate,
      FilterEndDate: filterEndDate,
      pageNumber: pageNumber,
      pageSize: pageSize,
      WFHcategory: wfhStatusName,
    };
    try {
      const responce = await getWFHDetails(param);
      setIsloading(false);
      // setWFHData(responce?.Data);
      setWFHData(
        responce?.Data?.map((item) => ({
          ...item,
          showFull: false,
        }))
      );
      setTotalRecords(responce?.Data[0]?.TotalCount);
    } catch {
      setIsloading(false);
    }
  }

  useEffect(() => {
    if (filterStartDate && filterEndDate) {
      getWFHData(typeAddOnClass, pageNumber, pageSize);
    }
  }, [filterStartDate, filterEndDate]);

  useEffect(() => {
    if (masterSystemAlertData?.length > 0) {
      toster.current.success(masterSystemAlertData);
    }
  }, [masterSystemAlertData]);

  const handleResonChange = (e) => {
    setResonValue(e.target.value);
  };

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setNoData(msg?.Desc);
      }
    });
  }, []);

  const handleReasonChange = (e) => {
    setResonValue(e.target.value);
  };

  const withdrawalWfhList = async (submitType) => {
    if (submitType === "Withdrwal") {
      setIsloading(true);

      const body = {
        id: showAllUserDataModel?.Id ?? 0,
        Reason: resonValue ?? "",
        RequestorId: showAllUserDataModel?.EmpId,
      };

      let completeLeaveList = await withdrawalWFHData(body);

      if (completeLeaveList.StatusCode !== 2000) {
        toster.current.warn(completeLeaveList?.Message);
        setIsloading(false);
        return false;
      } else {
        getWFHData("C", pageNumber, pageSize);
        toster.current.success(completeLeaveList?.Message);
        document.querySelector("#pending-request .btn-close")?.click();
        GetMasterSystemAlertList("WFH_Withdrawal", 0);
        setIsloading(false);
      }
    }
  };

  const onPageChange = async (event) => {
    setFirst(event.first);
    setRows(event.rows);
    setPageNumber(event.page + 1);  
       setPageSize(event.rows); 
    await getWFHData(typeAddOnClass, event.page + 1, event.rows);
  };

  const handleToggle = (index) => {
    if (showWfhHistory === index) {
      setshowWfhHistory(null); // Close if already expanded
    } else {
      setshowWfhHistory(index); // Open the clicked item
    }
  };

  useEffect(() => { }, [WFHData, empIdHierechy]);

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid position-relation">
        <div className="row g-3">
          <div className="form-head d-flex flex-wrap align-items-center mb-3">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">{T("WFH's")}</h2>
            </div>
            <WfhNavBarItems />
          </div>

          <div className="col-xl-8">
            <div className="leave-card tile-grid tile-grid-v1">
              <div className="card">
                <div className="tab-tabsa">
                  <div className="div">
                    <a onClick={() => getWFHData("U")}>
                      <h2
                        className={`font-w600 mb-0 ${typeAddOnClass == "U" ? "h2active" : ""
                          }`}
                      >
                        Upcoming
                      </h2>
                    </a>
                  </div>
                  <div className="div">
                    <a onClick={() => getWFHData("C")}>
                      <h2
                        className={`font-w600 mb-0 ${typeAddOnClass == "C" ? "h2active" : ""
                          }`}
                      >
                        Archived
                      </h2>
                    </a>
                  </div>
                  <div className="div">
                    <a onClick={() => getWFHData("P")}>
                      <h2
                        className={`font-w600 mb-0 ${typeAddOnClass == "P" ? "h2active" : ""
                          }`}
                      >
                        Pending
                      </h2>
                    </a>
                  </div>
                  <div className="div side-filter">
                    <div className="filter-down">
                      <div className="tab-tabsa1">
                        <div className="form-group d-gridcss mb-0">
                          <label>Start Date</label>
                          <input
                            type={inputType}
                            name="startDate"
                            className="form-control"
                            placeholder="Start Date"
                            onFocus={() => setInputType("date")}
                            onBlur={() => setInputType("text")}
                            value={filterStartDate}
                            onChange={(e) => setFilterStartDate(e.target.value)}
                          />
                          <label>End Date</label>
                          <input
                            type={inputType}
                            name="endDate"
                            className="form-control"
                            placeholder="End Date"
                            onFocus={() => setInputType("date")}
                            onBlur={() => setInputType("text")}
                            value={filterEndDate}
                            onChange={(e) => setFilterEndDate(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card filter-down d-none">
                <div className="card-body">
                  <div className="tab-tabsa1">
                    <div className="form-group d-flex mb-2">
                      <input
                        type="date"
                        name=""
                        onClick={(e) =>
                          e.target.showPicker && e.target.showPicker()
                        }
                        className="form-control me-3"
                        placeholder="Start Date"
                        onFocus="(this.type='date')"
                      />
                      <span className="tocss">To</span>
                      <input
                        type="date"
                        name=""
                        onClick={(e) =>
                          e.target.showPicker && e.target.showPicker()
                        }
                        className="form-control ml-3"
                        placeholder="End Date"
                        onFocus="(this.type='date')"
                      />
                    </div>
                    <div className="widthdiv">
                      <select
                        className="default-select wide form-control"
                        id="validationCustom05"
                      >
                        <option data-display="Select Status">
                          Select Status
                        </option>
                        <option value="html">Upcoming</option>
                        <option value="css">Approved</option>
                        <option value="javascript">Pending</option>
                      </select>
                    </div>

                    <div className="widthdiv">
                      <select
                        className="default-select wide form-control"
                        id="validationCustom05"
                      >
                        <option data-display="Select Type">Select Type</option>
                        <option value="html">Direct Report</option>
                        <option value="css">Hierarchy</option>
                      </select>
                    </div>

                    <div className="apply-filter">
                      <Link to="">{T("Apply")}</Link>
                    </div>
                  </div>
                </div>
              </div>
              {WFHData?.map((wfh, index) => {
                return (
                  <div className="leave-cards">
                    <div key={index}>
                      <div className="my-leavecard-list">
                        <div className="leave-container">
                          <img
                            src="images/org-img/leave/upcoming1.png"
                            className="w-100  leave-image"
                          />
                          <div className="leave-count-overlay">
                            {wfh?.Days}
                          </div>
                        </div>
                        <div className="leave-body">
                            {/* <div class="leave-type-row">
                              <span className="leave-type"> {" "} {wfh?.WFHTypeName}</span>
                            </div> */}
                            <p className="leave-description">
                              {wfh?.Reason?.length > 75 &&
                                !wfh?.showFull ? (
                                <>
                                  {wfh?.Reason.slice(0, 75)}...
                                  <span
                                    style={{
                                      color: "red",
                                      cursor: "pointer",
                                      fontSize: "12px",
                                    }}
                                    onClick={() => showFull(wfh.Id, true)}
                                  >
                                    read more
                                  </span>
                                </>
                              ) : (
                                wfh?.Reason
                              )}
                              {wfh?.showFull && (
                                <span
                                  style={{
                                    color: "red",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                  }}
                                  onClick={() => showFull(wfh.Id, false)}
                                >
                                  &nbsp; read less
                                </span>
                              )}
                            </p>
                            <div className="leave-meta">
                              <div className="meta-item">
                                <span className="meta-label">From:</span>
                                <span className="meta-value"> {moment(wfh?.StartDate).format("MMM DD YYYY")}</span>
                              </div>
                              <div className="meta-item">
                                <span className="meta-label">To:</span>
                                <span className="meta-value"> {moment(wfh?.EndDate).format("MMM DD YYYY")}</span>
                              </div>
                              <div className="meta-item">
                                <span className="meta-label">Half Day:</span>
                                <span className="meta-value">  {wfh?.IsHalfDay == false && (
                                  <span>No</span>
                                )}{" "}
                                  {wfh?.IsHalfDay == true && <span>{wfh?.HalfPreference}</span>}</span>
                              </div>
                              <div className="innerdiv d-flex align-items-center ml-auto">
                                {wfh?.WFHStatusId === 103 && (
                                  <a className="approved-status-btn">
                                    <i
                                      className="fa fa-clock-o"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    {wfh?.WFHStatusName}
                                  </a>
                                )}
                                {wfh?.WFHStatusId != 103 && (
                                  <a className="approved-status-btn">
                                    <i
                                      className="fa fa-clock-o"
                                      aria-hidden="true"
                                    ></i>{" "}
                                    {wfh?.WFHStatusName}
                                  </a>
                                )}
                                {/* {wfh?.WFHStatusId === 103 && ( */}
                                {((wfh?.WFHStatusId === 103 &&
                                  wfh?.EndDate.split(" ") >=
                                  new Date().toISOString().split("T")[0]) ||
                                  (wfh?.WFHStatusId != 104 &&
                                    wfh?.EndDate.split(" ") >=
                                    new Date().toISOString().split("T")[0] &&
                                    wfh?.WFHStatusId != 102)) && (
                                    <a
                                      className="withdraw-status-btn"
                                      data-bs-toggle="modal"
                                      data-bs-target="#pending-request"
                                      onClick={() => {
                                        {
                                          setshowAllUserDataModel(wfh);
                                          setResonValue("");
                                        }
                                      }}
                                    >
                                      <i
                                        className="fa fa-clock-o"
                                        aria-hidden="true"
                                      ></i>{" "}
                                      Withdraw
                                    </a>
                                  )}
                              </div>
                            </div>
                        </div>
                        <div className="innerdiv show-more"
                          onClick={() => handleToggle(index)}
                        >
                          {showWfhHistory === index ? (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-chevron-down"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fillRule="evenodd"
                                d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                              />
                            </svg>
                          ) : (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-chevron-up"
                              viewBox="0 0 16 16"
                            >
                              {" "}
                              <path
                                fillRule="evenodd"
                                d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
                              />
                            </svg>
                          )}
                        </div>
                      </div>
                      {showWfhHistory === index && (
                        <div className="my-leavedetail-view">
                          {wfh?.EmpWFHHistory?.length > 0 ? (
                            wfh?.EmpWFHHistory?.reverse()?.map(
                              (history, Hindex) => (
                                <div key={history?.Id}>
                                  <ul className="timeline">
                                    <li className="timeline-inverted">
                                      <div className="timeline-badge">1</div>
                                      <div className="timeline-panel">
                                        <div className="flex-container flex-around">
                                          <div className="timeline-heading">
                                            <h4 className="timeline-title">
                                              {history?.ModifiedByName}
                                            </h4>
                                            {history?.LeaveStatusName === "Applied" && history?.Reason ? (
                                                <p className="timeline-title">{history.Reason}</p>
                                              ) : history?.Comments ? (
                                                <p className="timeline-title">{history.Comments}</p>
                                              ) : null}
                                            {/* {history?.CreatedBy === history?.ModifiedBy ? (
                                                history?.Reason?.length > 0 && (
                                                  <p className="timeline-title">
                                                    {history.Reason}
                                                  </p>
                                                )
                                              ) : (
                                                history?.Comments?.length > 0 && (
                                                  <p className="timeline-title">
                                                    {history.Comments}
                                                  </p>
                                                )
                                              )} */}
                                            <h5 className="leavestatus-timeline">
                                              <i
                                                className="fa fa-clock-o"
                                                aria-hidden="true"
                                              ></i>
                                              {history?.WFHStatusName}
                                              <span>
                                                on{" "}
                                                {moment(
                                                  history?.ModifiedDate
                                                ).format("MMM DD YYYY")}{" "}
                                                (
                                                {new Date(
                                                  history?.ModifiedDate
                                                ).toLocaleTimeString([], {
                                                  hour: "numeric",
                                                  minute: "2-digit",
                                                })}
                                                )
                                              </span>
                                            </h5>
                                          </div>
                                          <div className="timeline-clock">
                                            <p>
                                              <i className="glyphicon glyphicon-time"></i>
                                              {moment(
                                                history?.ModifiedDate
                                              ).format("MMM DD YYYY")}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              )
                            )
                          ) : (
                            <div>No WFH History Found.</div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
              {WFHData?.length === 0 || WFHData == null ? (
                <div className="no-data center-align-img">
                  <img src="/images/no-data-found/Noworkfromhome.png" />
                  <p>{noData}</p>
                </div>
              ) : (
                <div className="card pagination-css">
                  <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={totalRecords}
                    rowsPerPageOptions={[10, 20, 30]}
                    onPageChange={onPageChange}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-4">
            <div className="row sidecarddd">
              <div className="col-xl-12">
                <WfhManagerReport />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="pending-request">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content withdrawleave">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
              <div className="img">
                <img src="/images/org-img/leave/withdrawal.png" />
              </div>
            </div>
            <form onSubmit={withdrawalWfhList}>
              <div className="modal-body text-center">
                <strong className="modal-title d-block">
                  Withdrawal Request
                </strong>

                <div className="inner">
                  <div className="h-avatar">
                    <LazyImage
                      className="avatar"
                      src={userDetails?.ProfileImage}
                      alt={userDetails?.FullName}
                    />
                  </div>
                  <div className="para-detail">
                    <span className="name-p">
                      {showAllUserDataModel?.EmployeeName}
                    </span>
                    applied
                    <span>
                      <b>From </b>-
                      {moment(showAllUserDataModel?.StartDate).format(
                        "MMM DD YYYY"
                      )}
                    </span>
                    <span>
                      <b>To </b>-
                      {moment(showAllUserDataModel?.EndDate).format(
                        "MMM DD YYYY"
                      )}
                    </span>
                    {showAllUserDataModel.IsHalfDay == true && (
                      <span>
                        with
                        {/* {showAllUserDataModel.IsHalfDay == false && (
                        <span>No Half Day</span>
                      )}{" "} */}
                        {showAllUserDataModel.IsHalfDay == true && (
                          <span>{showAllUserDataModel.HalfPreference}</span>
                        )}
                        {/* <b> {showAllUserDataModel.HalfPreference} </b> */}
                      </span>
                    )}

                  </div>
                </div>
                <label className="mt-3">Reason</label>
                {/* <textarea
                  rows="2"
                  cols="1"
                  className="form-control"
                  value={resonValue}
                  onChange={handleResonChange}
                  placeholder="Reason"
                ></textarea> */}
                <textarea
                  rows="2"
                  cols="1"
                  className={`form-control`}
                  value={resonValue}
                  onChange={handleReasonChange}
                  placeholder="Reason"
                  maxLength={500}
                ></textarea>
                <div
                  style={{
                    textAlign: "right",
                    fontSize: "12px",
                    position: "absolute",
                    right: "47px",
                    bottom: "17px",
                    color: resonValue.length === 500 ? "red" : "#555",
                  }}
                >
                  {resonValue.length}/{500}
                </div>
              </div>
            </form>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={() => withdrawalWfhList("Withdrwal")}
                className="savebtn-click"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
      <TosterService ref={toster} />
      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}
export default MyWfh;
